import { ApiResponse } from '@cineamo/api/types/ApiResponse.types';

export type EmbeddedOf<QueryFnReturnValue> = QueryFnReturnValue extends { _embedded?: infer QueryResultEmbedded }
    ? QueryResultEmbedded
    : never;
export type ItemOfEmbedded<
    QueryResultEmbedded,
    QueryResultEmbeddedKeys extends keyof QueryResultEmbedded
> = QueryResultEmbedded[QueryResultEmbeddedKeys] extends (infer I)[] ? I : never;

export async function getAllListItems<
    QueryFn extends (...args: unknown[]) => Promise<ApiResponse>,
    QueryFnReturnValue = Awaited<ReturnType<QueryFn>>,
    QueryResultEmbedded = NonNullable<EmbeddedOf<QueryFnReturnValue>>,
    QueryResultEmbeddedKeys extends keyof QueryResultEmbedded = keyof QueryResultEmbedded
>(options: {
    queryFn: QueryFn;
    listAccessor: QueryResultEmbeddedKeys;
    page?: number;
}): Promise<ItemOfEmbedded<QueryResultEmbedded, QueryResultEmbeddedKeys>[]> {
    const page = options.page || 1;
    const queryFn = options.queryFn;
    const listAccessor = options.listAccessor;
    const firstPage = await queryFn(page);
    const pageRequests = [];
    if (firstPage?._page_count > 1) {
        for (let nextPage = page + 1; nextPage <= firstPage._page_count; nextPage++) {
            pageRequests.push(queryFn(nextPage));
        }
    }
    const otherPages = await Promise.all(pageRequests);
    const pages = [firstPage, ...otherPages];
    return pages.flatMap((page) =>
        page?._embedded && listAccessor in page._embedded ? page._embedded?.[listAccessor] : []
    );
}
